"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelector = useSelector;
var _withSelector = require("use-sync-external-store/shim/with-selector");
// We need to import the shim because React 17 does not support the `useSyncExternalStore` API.

function useSelector(store, selector, a1, a2, a3) {
  const selectorWithArgs = state => selector(state, a1, a2, a3);
  return (0, _withSelector.useSyncExternalStoreWithSelector)(store.subscribe, store.getSnapshot, store.getSnapshot, selectorWithArgs);
}